import { Link } from "react-router-dom";

export default function BlogListItem( { item } ){

    let title = item.properties.Name?.title[0]?.plain_text;
    let summary = item.properties.Summary?.rich_text?.[0]?.plain_text;
    let date = item.properties.Date.formula.string;
    let days = item.properties.Days.formula.string;
    let tags = item.properties.Tags.multi_select;
    let category = item.properties.Category.multi_select;
    let link = item.properties.Link?.rich_text?.[0]?.plain_text;

    let created = item.properties.Created_date.formula.string;
    let edited = item.properties.Edited_date.formula.string;

    let thumbnail = item.icon?.file?.url || null;

    return(
        <Link to = {`/blog/${item.id}`} state = { { title : title, summary : summary, date : date, tags : tags, created : created, edited : edited, category : category, days : days, link : link } } style = { { textDecoration : "none" } }>
            <div style = { { display : "flex", width : "100%", borderBottom : "solid 1px var(--black8)", paddingTop : "24px", paddingBottom : "24px" } }>
                <div className = "bloglistitem" style = { { width : "calc(100% - 120px)" } }>                    
                    <h3 className = "blogTitle">{ title }</h3>

                    { summary ? <p className = "summary" style = { { color : "var(--black56)"} }>{ summary }</p> : "" }

                    <div style = { { display : "flex", marginTop : "4px" } }>
                        <p style = { { fontSize : "10px", color : "var(--black56" } }>{ date } · { days }</p>
                    </div>
                </div>

                { thumbnail && (
                    <div style = { { width: "400px", height: "80px", backgroundImage: `url(${thumbnail})`, backgroundSize: "cover", backgroundPosition: "center" } } />                  
                )}
            </div>
      </Link>
    )
}